import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';

// = styles =
// 3rd
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/products.scss';
import 'styles/app.scss';
import 'styles/main.scss';
import 'styles/productEdit.scss';
import 'styles/models.scss';

import lightTheme from './themes/lightTheme';
import darkTheme from './themes/darkTheme';
import grayTheme from './themes/grayTheme';

import pinkTheme from './themes/pinkTheme';
import yellowTheme from './themes/yellowTheme';
import multuTheme from './themes/multuTheme';
import kazakhTheme from "./themes/kazakhTheme";
import romanianTheme from "./themes/romanianTheme";

import {NotificationContainer} from "react-notifications";
import 'react-notifications/lib/notifications.css';

import 'font-awesome/css/font-awesome.min.css';
import settingsActions from "../actions/settings.actions";
import hungarianTheme from "./themes/hungarianTheme";
import croatianTheme from "./themes/croatianTheme";

injectTapEventPlugin(); // Needed for onTouchTap for Material UI

ThemedStyleSheet.registerTheme(lightTheme);

class App extends Component {

  componentDidMount = () => {
    this.props.getLocales();
    this.props.getSettings();

    // hashHistory.listen(location => {
    //   console.log('hashHistory listen', location, this.props.isUserLogged);
    // });
  };

  componentWillReceiveProps = (props) => {
    // if (!this.props.isUserLogged && props.location.pathname !== "/login") {
    //   hashHistory.push("/login");
    //   NotificationContainer.warn("Brak dostępu.", "Prosimy się zalogować. Dostęp do tej części systemu posiadają tylko zalogowani użytkownicy.", 5000);
    // }

    if (props.theme && this.props.theme && props.theme !== this.props.theme) {
      ThemedStyleSheet.register(this.currentTheme);
    }
  };

  get currentTheme() {
    let materialUITheme;
    switch (this.props.theme) {
      case 'gray':
        materialUITheme = grayTheme;
        break;
      case 'dark':
        materialUITheme = darkTheme;
        break;
      case 'pink':
        materialUITheme = pinkTheme;
        break;
      case 'yellow':
        materialUITheme = yellowTheme;
        break;
      case 'multu':
        materialUITheme = multuTheme;
        break;
      case 'kazakh':
        materialUITheme = kazakhTheme;
        break;
      case 'romanian':
        materialUITheme = romanianTheme;
        break;
      case 'hungarian':
        materialUITheme = hungarianTheme;
        break;
      case 'croatian':
        materialUITheme = croatianTheme;
        break;
      default:
        materialUITheme = lightTheme;
    }

    return materialUITheme;
  }

  render() {
    const { layoutBoxed, navCollapsed, navBehind, fixedHeader, sidebarWidth, theme } = this.props;

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(this.currentTheme)}>
        <div id="app-inner">
          <NotificationContainer />
          <div className="preloaderbar hide"><span className="bar" /></div>
          <div
            className={classnames('app-main full-height', {
              'fixed-header': fixedHeader,
              'nav-collapsed': navCollapsed,
              'nav-behind': navBehind,
              'layout-boxed': layoutBoxed,
              'theme-gray': theme === 'gray',
              'theme-dark': theme === 'dark',
              'sidebar-sm': sidebarWidth === 'small',
              'sidebar-lg': sidebarWidth === 'large'})
                    }>
            {this.props.children}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  layoutBoxed: state.preferences.layoutBoxed,
  navCollapsed: state.preferences.navCollapsed,
  navBehind: state.preferences.navBehind,
  fixedHeader: state.preferences.fixedHeader,
  sidebarWidth: state.preferences.sidebarWidth,
  theme: state.preferences.theme,

  isUserLogged: state.users.isLogged,
});

const mapDispatchToProps = (dispatch, props) => {
  return {
    getLocales: () => dispatch(settingsActions.getLocales()),
    getSettings: () => dispatch(settingsActions.getSettings()),
  };
};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./containers/App.js